import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/keepalive'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_keepalive_index',
          meta: {
            permissions: ['administrator', 'account_manage'],
          },
          component: () => import('./Index.vue'),
        },
      ],
    },
  ],
};
